import React, { useEffect, useRef, useState } from "react";
import {
  TextField,
  Grid,
  Typography,
  Avatar,
  Box,
  Autocomplete, MenuItem
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import CompanyVeiwController from "../../../redux/actions/companyApiActions";
import { getUserInfoFromToken } from "../../../utils/authUtils";



const BasicInformationForm = ({ formik }) => {
  const { values, errors, touched, handleChange, handleBlur, setFieldValue } = formik;
  // const userType = localStorage.getItem("user_type");

  const dispatch = useDispatch();
  const { getCompanies } = CompanyVeiwController();
  const { companies } = useSelector((state) => state.company);
  const [userType, setUserType] = useState(null);
  const [userId, setUserId] = useState(null);
  useEffect(() => {
    dispatch(getCompanies());
  }, [dispatch]);
    const formikRef = useRef();
              useEffect(() => {
              const { userType, userId } = getUserInfoFromToken();
              setUserType(userType);
              setUserId(userId);
            }, []);

  return (
    <>
      <Grid container spacing={2} mt={1}>
        {userType === "Admin" &&(
         <Grid item xs={12}>
          <TextField
            select
            fullWidth
            label="Company"
            name="company_id"
            value={values.company_id}
            onChange={handleChange}
            error={touched.company_id && Boolean(errors.company_id)}
            helperText={touched.company_id && errors.company_id}
            >
            <MenuItem value="">Select Company</MenuItem>
            {companies.map((c) => (
            <MenuItem key={c.id} value={c.id}>
            {c.company_name}
            </MenuItem>
            ))}
            </TextField>
        </Grid>
        )}
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="First Name"
            name="first_name"
            value={values.first_name}
            onChange={handleChange}
            onBlur={handleBlur}
            error={touched.first_name && Boolean(errors.first_name)}
            helperText={touched.first_name && errors.first_name}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="Last Name"
            name="last_name"
            value={values.last_name}
            onChange={handleChange}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="Email"
            name="email"
            value={values.email}
            onChange={handleChange}
            error={touched.email && Boolean(errors.email)}
            helperText={touched.email && errors.email}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default BasicInformationForm;
